<template>
    <div>
        <p>{{addModity.categoryName}}</p>
        <p>{{addModity.officicalModel}}/{{addModity.modityName}}</p>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    props:['addModity']
}
</script>




// WEBPACK FOOTER //
// src/views/admin/store/store-nameModel.vue